import gql from 'graphql-tag';

export default gql`
  mutation fixTreatment($input: FixTreatmentInput) {
    fixTreatment(input: $input) {
      id
    }
  }
`;
